exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pricelists-table{max-width:1024px}.pricelist-dialog .full-width+.md-table tbody .md-table-row td{border-top:0}.pricelist-dialog{width:100%;max-width:1430px;overflow-y:scroll}.category-number{margin:30px 0}input[disabled=disabled]{-webkit-text-fill-color:#ddd!important}.md-field.md-disabled:after{opacity:.2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e3364642","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Tickets/Pricelists.vue
// module id = 291
// module chunks = 0